module.exports = __webpack_public_path__ + "img/sport-1-@1x.4106c0ef.png";